import ApiBaseService from './ApiBaseService.js';

class EmployerService {

  //file upload
  static uploadFile([formData]) {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    return ApiBaseService.request(`api/file/upload`, "POST", formData, headers);
  }
  //change password
  static changePassword([data]) {
    return ApiBaseService.request(`api/auth/changepwd`, "POST", data);
  }
  //employee employees-list
  static getEmployees([company_uuid, page, limit = 0, searchText = '', filter = 'all', employee = '']) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee?page=${page}&limit=${limit}&search=${searchText}&filter=${filter}&employee=${employee}`, "GET");
  }
  //company-settings
  static getCompanySettings([company_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}`, "GET", null);
  }
  static getCompanySettingsProgress([company_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/profile-status`, 'GET', null);
  }

  //company-settings basic info
  static createCompanyInfo([data]) {
    return ApiBaseService.request(`api/company`, "POST", data);
  }
  static updateCompanyInfo([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}`, "PUT", data);
  }

  // employee list
  static getCompanyEmployeeList([company_uuid, page = 0, pagination]) {
    if (pagination >= 0) {
      return ApiBaseService.request(`api/company/${company_uuid}/employee?pagination=${page}&pagination=${pagination}`, "GET");
    } else {
      return ApiBaseService.request(`api/company/${company_uuid}/employee?pagination=${page}`, "GET");
    }
  }
  static sendMailCredentials([company_uuid, employee_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/credentials`, "GET");
  }

  //company-settings locations
  static getCompanyLocations([company_uuid, page = 0, limit = 0, pagination]) {
    if (pagination >= 0) {
      return ApiBaseService.request(`api/company/${company_uuid}/location?page=${page}&limit=${limit}&pagination=${pagination}`, "GET");
    } else {
      return ApiBaseService.request(`api/company/${company_uuid}/location?page=${page}&limit=${limit}`, "GET");
    }
  }
  static addCompanyLocation([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/location`, "POST", data);
  }
  static updateCompanyLocation([company_uuid, location_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/location/${location_uuid}`, "PUT", data);
  }
  static deleteCompanyLocation([company_uuid, location_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/location/${location_uuid}`, "DELETE");
  }
  static getPtState([company_uuid, pagination = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/pt-state?pagination=${pagination}`, "GET");
  }

  //company-settings department
  static getCompanyDepartments([company_uuid, page = 0, limit = 0, pagination]) {
    if (pagination >= 0) {
      return ApiBaseService.request(`api/company/${company_uuid}/department?page=${page}&limit=${limit}&pagination=${pagination}`, "GET");
    } else {
      return ApiBaseService.request(`api/company/${company_uuid}/department?page=${page}&limit=${limit}`, "GET");
    }
  }
  static addCompanyDepartment([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/department`, "POST", data);
  }
  static updateCompanyDepartment([company_uuid, department_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/department/${department_uuid}`, "PUT", data);
  }
  static deleteCompanyDepartment([company_uuid, department_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/department/${department_uuid}`, "DELETE");
  }

  //company-settings designation
  static getCompanyDesignations([company_uuid, page = 0, limit = 0, pagination]) {
    if (pagination >= 0) {
      return ApiBaseService.request(`api/company/${company_uuid}/designation?page=${page}&limit=${limit}&pagination=${pagination}`, "GET");
    } else {
      return ApiBaseService.request(`api/company/${company_uuid}/designation?page=${page}&limit=${limit}`, "GET");
    }
  }
  static addCompanyDesignation([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/designation`, "POST", data);
  }
  static updateCompanyDesignation([company_uuid, designation_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/designation/${designation_uuid}`, "PUT", data);
  }
  static deleteCompanyDesignation([company_uuid, designation_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/designation/${designation_uuid}`, "DELETE");
  }

  //company-settings projects
  static getCompanyProjects([company_uuid, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project?page=${page}&limit=${limit}`, "GET");
  }
  static addCompanyProject([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project`, "POST", data);
  }
  static updateCompanyProject([company_uuid, project_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project/${project_uuid}`, "PUT", data);
  }
  static deleteCompanyProject([company_uuid, project_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project/${project_uuid}`, "DELETE");
  }

  //company-settings tasks
  static getCompanyTasks([company_uuid, project_uuid, pagination = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project/${project_uuid}/task?pagination=${pagination}`, "GET");
  }
  static addCompanyTask([company_uuid, project_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project/${project_uuid}/task`, "POST", data);
  }
  static updateCompanyTask([company_uuid, project_uuid, task_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project/${project_uuid}/task/${task_uuid}`, "PUT", data);
  }
  static deleteCompanyTask([company_uuid, project_uuid, task_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/project/${project_uuid}/task/${task_uuid}`, "DELETE");
  }

  //company-settings expense category
  static getCompanyExpenseCategories([company_uuid, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expcat?page=${page}&limit=${limit}`, "GET");
  }
  static addCompanyExpenseCategory([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expcat`, "POST", data);
  }
  static updateCompanyExpenseCategory([company_uuid, expense_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expcat/${expense_uuid}`, "PUT", data);
  }
  static deleteCompanyExpenseCategory([company_uuid, expense_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expcat/${expense_uuid}`, "DELETE");
  }

  //company-settings assets
  static getCompanyAssets([company_uuid, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/assetcat?page=${page}&limit=${limit}`, "GET");
  }
  static addCompanyAsset([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/assetcat`, "POST", data);
  }
  static updateCompanyAsset([company_uuid, expense_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/assetcat/${expense_uuid}`, "PUT", data);
  }
  static deleteCompanyAsset([company_uuid, expense_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/assetcat/${expense_uuid}`, "DELETE");
  }

  //company-settings payroll components
  static getCompanyPayrollComponents([company_uuid, page = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/paycom?pagination=${page}`, "GET");
  }
  static addCompanyPayrollComponent([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/paycom`, "POST", data);
  }
  static updateCompanyPayrollComponent([company_uuid, paycom_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/paycom/${paycom_uuid}`, "PUT", data);
  }
  static deleteCompanyPayrollComponent([company_uuid, paycom_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/paycom/${paycom_uuid}`, "DELETE");
  }

  //company-settings leaves
  static getCompanyLeaves([company_uuid, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/leavequota?page=${page}&limit=${limit}`, "GET");
  }
  static addCompanyLeave([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/leavequota`, "POST", data);
  }
  static updateCompanyLeave([company_uuid, leavequota_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/leavequota/${leavequota_uuid}`, "PUT", data);
  }
  //company-settings leaves -> calendar
  static uploadCalendar([company_uuid, formData]) {
    const headers = {
      "Content-Type": "multipart/form-data",
    };
    return ApiBaseService.request(`api/company/${company_uuid}/calendar-upload`, "POST", formData, headers);
  }
  static getCompanyCalendars([company_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/calendars`, "GET");
  }
  static deleteCompanyCalendar([company_uuid, year, calname]) {
    return ApiBaseService.request(`api/company/${company_uuid}/calendar?year=${year}&name=${calname}`, "DELETE");
  }
  static getCompanyCalendarHolidays([company_uuid, year, calname]) {
    return ApiBaseService.request(`api/company/${company_uuid}/calendar?year=${year}&calname=${calname}`, "GET");
  }
  static addCompanyCalendarHoliday([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/calendar`, "POST", data);
  }
  static updateCompanyCalendarHoliday([company_uuid, event_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/calendar/${event_uuid}`, "PUT", data);
  }
  static deleteCompanyCalendarHoliday([company_uuid, event_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/calendar/${event_uuid}`, "DELETE");
  }
  static downloadTemplate([company_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/calendar-template`, "GET");
  }

  //employee profile progress
  static getEmployeeProfileProgress([company_uuid, employee_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/profile-status`, 'GET', null);
  }

  //company-settings shifts/schedule
  static getCompanyShifts([company_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/shift`, "GET");
  }
  static addCompanyShift([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/shift`, "POST", data);
  }
  static updateCompanyShift([company_uuid, shift_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/shift/${shift_uuid}`, "PUT", data);
  }
  static deleteCompanyShift([company_uuid, shift_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/shift/${shift_uuid}`, "DELETE");
  }

  //employee-details info
  static getEmployeeDetails([company_uuid, employee_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}`, "GET", null);
  }
  static addEmployeeDetails([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee`, "POST", data);
  }
  static updateEmployeeDetails([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}`, "PUT", data);
  }

  //employee-details leaves
  static getEmployeeLeaves([company_uuid, employee_uuid, startYear]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/leavequota?startYear=${startYear}`, "GET");
  }
  static updateEmployeeLeave([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/leavequota`, "PUT", data);
  }

  //employee-details work experience
  static getEmployeeWorkExperiences([company_uuid, employee_uuid, pagination = 0, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/experience?pagination=${pagination}&page=${page}&limit=${limit}`, "GET");
  }
  static addEmployeeWorkExperience([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/experience`, "POST", data);
  }
  static updateEmployeeWorkExperience([company_uuid, employee_uuid, experience_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/experience/${experience_uuid}`, "PUT", data);
  }
  static deleteEmployeeWorkExperience([company_uuid, employee_uuid, experience_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/experience/${experience_uuid}`, "DELETE");
  }

  //employee-details education
  static getEmployeeEducations([company_uuid, employee_uuid, pagination = 0, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/education?pagination=${pagination}&page=${page}&limit=${limit}`, "GET");
  }
  static addEmployeeEducation([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/education`, "POST", data);
  }
  static updateEmployeeEducation([company_uuid, employee_uuid, education_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/education/${education_uuid}`, "PUT", data);
  }
  static deleteEmployeeEducation([company_uuid, employee_uuid, education_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/education/${education_uuid}`, "DELETE");
  }

  //employee-details certificates
  static getEmployeeCertificates([company_uuid, employee_uuid, pagination = 0, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/certification?pagination=${pagination}&page=${page}&limit=${limit}`, "GET");
  }
  static addEmployeeCertificate([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/certification`, "POST", data);
  }
  static updateEmployeeCertificate([company_uuid, employee_uuid, certificate_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/certification/${certificate_uuid}`, "PUT", data);
  }
  static deleteEmployeeCertificate([company_uuid, employee_uuid, certificate_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/certification/${certificate_uuid}`, "DELETE");
  }

  //employee-profile skills
  static getEmployeeSkills([company_uuid, employee_uuid, page = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/skill?pagination=${page}`, "GET");
  }
  static addEmployeeSkill([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/skill`, "POST", data);
  }
  static updateEmployeeSkill([company_uuid, employee_uuid, skill_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/skill/${skill_uuid}`, "PUT", data);
  }
  static deleteEmployeeSkill([company_uuid, employee_uuid, skill_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/skill/${skill_uuid}`, "DELETE");
  }

  //employee-details assets
  static getEmployeeAssets([company_uuid, employee_uuid, pagination = 0, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/asset?pagination=${pagination}&page=${page}&limit=${limit}`, "GET");
  }
  static addEmployeeAsset([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/asset`, "POST", data);
  }
  static updateEmployeeAsset([company_uuid, employee_uuid, asset_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/asset/${asset_uuid}`, "PUT", data);
  }
  static deleteEmployeeAsset([company_uuid, employee_uuid, asset_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/asset/${asset_uuid}`, "DELETE");
  }

  //employee-details documents
  static getEmployeeDocuments([company_uuid, employee_uuid, pagination = 0, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/document?pagination=${pagination}&page=${page}&limit=${limit}`, "GET");
  }
  static addEmployeeDocument([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/document`, "POST", data);
  }
  static updateEmployeeDocument([company_uuid, employee_uuid, document_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/document/${document_uuid}`, "PUT", data);
  }
  static deleteEmployeeDocument([company_uuid, employee_uuid, document_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/document/${document_uuid}`, "DELETE");
  }

  //employee-details banks
  static getEmployeeBanks([company_uuid, employee_uuid, pagination = 0, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/bankaccount?pagination=${pagination},page=${page}&limit=${limit}`, "GET");
  }
  static addEmployeeBank([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/bankaccount`, "POST", data);
  }
  static updateEmployeeBank([company_uuid, employee_uuid, bankaccount_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/bankaccount/${bankaccount_uuid}`, "PUT", data);
  }
  static changeDefaultAccount([company_uuid, employee_uuid, bankaccount_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/bankaccount/${bankaccount_uuid}/default`, "GET", null);
  }
  static deleteEmployeeBank([company_uuid, employee_uuid, bankaccount_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/bankaccount/${bankaccount_uuid}`, "DELETE");
  }

  //company-settings expense
  static getCompanyDayExpenses([company_uuid, startDate, endDate, pagination = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expense?type=day&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
  }
  static getCompanyWeekExpenses([company_uuid, startDate, endDate, pagination = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expense?type=week&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
  }
  static getCompanyMonthExpenses([company_uuid, startDate, endDate, pagination = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expense?type=month&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
  }
  static addCompanyExpense([company_uuid, data]) {
    return ApiBaseService.request(`/api/company/${company_uuid}/expense`, "POST", data);
  }
  static updateCompanyExpense([company_uuid, expense_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expense/${expense_uuid}`, "PUT", data);
  }
  static deleteCompanyExpense([company_uuid, expense_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/expense/${expense_uuid}`, "DELETE");
  }

  //employee-details payroll
  static getEmployeePayrollList([company_uuid, employee_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/payroll`, "GET");
  }
  static getEmployeePayrolls([company_uuid, employee_uuid, payroll_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/payroll/${payroll_uuid}`, "GET");
  }
  static calculateEmployeePayroll([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/payroll-calc`, "POST", data);
  }
  static calculateByCTCEmployeePayroll([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/payroll-calc`, "POST", data);
  }
  static updateEmployeePayroll([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/payroll`, "POST", data);
  }
  static updateEmployeePayrollComponent([company_uuid, employee_uuid, payroll_uuid, epi_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/payroll/${payroll_uuid}/component/${epi_uuid}`, "PUT", data);
  }

  // exit-employee
  static exitEmployee([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/exit`, "POST", data);
  }
  static collectAsset([company_uuid, employee_uuid, asset_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/asset/${asset_uuid}/surrender`, "PUT", {});
  }

  // upload-employee
  static downloadEmployeeTemplate([company_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee-template-download`, "GET");
  }
  static uploadEmployee([company_uuid, formData]) {
    const headers = {
      'Content-Type': 'multipart/form-data',
    };
    return ApiBaseService.request(`api/company/${company_uuid}/employee-template-upload`, 'POST', formData, headers);
  }
  static downloadEmployee([company_uuid, filter, search]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee-download?search=${search}&filter=${filter}`, "GET");
  }

  //emplyee-details current employee
  static getCurrentEmployeeDetails([company_uuid, employee_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/ytd`, "GET", null);
  }
  static updateCurrentEmployeeDetails([company_uuid, employee_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/employee/${employee_uuid}/ytd`, 'POST', data);
  }

  //expense-approval
  static getExpenseTeam([company_uuid]) {
    return ApiBaseService.request(`api/company/${company_uuid}/approval/employees`, "GET");
  }
  static getExpenseApprovals([company_uuid, type, startDate, endDate, pagination = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/approval/expense?type=${type}&startDate=${startDate}&endDate=${endDate}&pagination=${pagination}`, "GET");
  }
  static reviewExpenseRequest([company_uuid, data]) {
    return ApiBaseService.request(`api/company/${company_uuid}/approval/expense`, "PUT", data);
  }

  // * To set companyUUID
  static getBasicProfile() {
    return ApiBaseService.request(`/api/company`, 'GET');
  }

  //Notification Settings
  static NotifiSettingsList([company_uuid, pagination = 0, page = 0, limit = 0]) {
    return ApiBaseService.request(`api/company/${company_uuid}/email-notification-settings?pagination=${pagination}&page=${page}&limit=${limit}`, "GET");
  }
  static notifiSettingsChange([company_uuid, itemUuid, status]) {
    return ApiBaseService.request(`api/company/${company_uuid}/email-notification-settings/${itemUuid}/status/${status}`, "PUT", {});
  }
}

export default EmployerService;
